export default (function ()
{
	const getModules = (_files) =>
	{
		const module = {};

		// TODO needs to be included in each function-execution because of compiling issues
		// * watch here: https://lightrun.com/answers/webpack-webpack-uncaught-typeerror-__webpack_require__context-is-not-a-function
		// const _files = require.context(_dir, true, /[A-Za-z0-9-_,\s]+\.js$/i);

		_files.keys().forEach(file =>
		{
			const matched = file.match(/([A-Za-z0-9-_]+)\./i);
			if (matched && matched.length > 1)
			{
				const locale = matched[1];

				module[locale] = {
					...module[locale],
					..._files(file),
				}.default;
			}
		});

		return module;
	}

	const filesFromDirectory = (_directory, _filenames) => {
		const components = {};
		_filenames.forEach(role => {
			components[role] = require(`@/${_directory}/${role}.vue`).default;
		});

		return components;
	}

	return {
		getModules,
		filesFromDirectory,
	}
})();
